import {
  REQUEST_FAILED,
  LIST,
  LIST_SUCCEEDED,
  GET,
  GET_SUCCEEDED,
  UPDATE,
  UPDATE_SUCCEEDED,
  REMOVE,
  REMOVE_SUCCEEDED,
  CREATE,
  CREATE_SUCCEEDED,
  SET,
  RESET,
} from './action-types';

export const requestFailed = error => ({ type: REQUEST_FAILED, error });
export const list = (idUser, idEnrollment) => ({ type: LIST, idUser, idEnrollment });
export const listSucceeded = data => ({ type: LIST_SUCCEEDED, data });
export const get = (idUser, idEnrollment) => ({ type: GET, idUser, idEnrollment });
export const getSucceeded = data => ({ type: GET_SUCCEEDED, data });
export const update = data => ({ type: UPDATE, data });
export const updateSucceeded = success => ({ type: UPDATE_SUCCEEDED, success });
export const remove = id => ({ type: REMOVE, id });
export const removeSucceeded = success => ({ type: REMOVE_SUCCEEDED, success });
export const create = data => ({ type: CREATE, data });
export const createSucceeded = success => ({ type: CREATE_SUCCEEDED, success });
export const set = (key, value) => ({ type: SET, key, value });
export const reset = () => ({ type: RESET });
